module.exports = __webpack_public_path__ + "i18n/es_5af482cc290da6c01c6d24c9be3f1656.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/es.json
// module id = +lAx
// module chunks = 153